import { Box, Chip, Typography } from "@mui/material";
import useColors from "../../../../../api/hooks/useColors";
import CustomToolTip from "../../../../../components/CustomTooltip";
import CustomTooltipBorder from "../../../../../components/CustomTooltipBorder";
import SvgToIcon from "../../../../../icons/SvgToIcon";

const FilterChip = ({
  label,
  handleDelete,
  handleOnCLick,
  showDeleteIcon = true,
  TooltipTitle = null,
  clickable = true,
  icon = null,
  sx = {},
}) => {
  const colors = useColors();
  const maxLabelLength = 21;
  const truncatedLabel =
    label.length > maxLabelLength
      ? `${label.slice(0, maxLabelLength)}...`
      : label;

  return (
    <CustomTooltipBorder
      title={TooltipTitle ? <TooltipTitle /> : null}
      disableHoverListener={TooltipTitle === null}
      borderColor={colors.common_white}
      placement={"bottom"}
    >
      <Chip
        key={label}
        sx={{
          background: colors.grey_8percent,
          border: "none",
          borderRadius: "8px",
          height: "16px",
          "& .MuiChip-deleteIcon ": {
            width: "12px",
          },
          ...sx,
        }}
        label={
          <Box
            display={"flex"}
            flexDirection={"row"}
            gap={1}
            alignItems={"flex-end"}
          >
            {icon && (
              <SvgToIcon
                IconLogo={icon}
                style={{
                  width: "18px",
                }}
              />
            )}
            <Typography
              variant="caption"
              key={label}
              sx={{
                cursor: clickable ? "pointer" : "default",
              }}
            >
              <Box
                onClick={handleOnCLick}
                style={{
                  textDecoration: "none",
                  borderBottom: "none",
                  cursor: clickable ? "pointer" : "default",
                }}
              >
                <CustomToolTip
                  title={label}
                  placement={"top"}
                  disableHoverListener={label.length <= maxLabelLength}
                >
                  {truncatedLabel}
                </CustomToolTip>
              </Box>
            </Typography>
          </Box>
        }
        onDelete={showDeleteIcon ? () => handleDelete(label) : null}
      />
    </CustomTooltipBorder>
  );
};

export default FilterChip;
